// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".callback-fixed{bottom:100px;position:fixed;right:100px;z-index:999}.callback-fixed img{height:100px;width:100px}@media screen and (max-width:1007px){.callback-fixed{bottom:10px;position:fixed;right:15px}.callback-fixed img{height:75px;width:75px}}@media(hover:none)and (pointer:coarse){.callback-fixed{bottom:91px;position:fixed;right:15px}.callback-fixed img{height:75px;width:75px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
